
























































































































































































































































































import Feedback from "@/components/actions/Feedback.vue";
import CustomerProduct from "@/components/headers/customer-products";
import router from "@/router";
import ExcelResponse from "@/types/app/excelResponse";
import Header from "@/types/app/header";
import UserInterface from "@/types/app/IUser";
import Product from "@/types/app/products";
import ProductExcel from "@/types/app/productsExcel";
import FeedBackInterface from "@/types/feedBack";
import applyCondition from "@/utils/applyCondition";
import Endpoint from "@/utils/endpoint";
import formatDate from "@/utils/formatDate";
//import ExcelColumnData from '@/types/app/excelColumnData';
import formatMoney from "@/utils/formatMoney";
import { getProducts } from "@/utils/getProducts";
import { putProductClearCache } from "@/utils/putProductClearCache";
import { truncate } from "@/utils/truncate";
import { AxiosInstance } from "axios";
import Vue from "vue";
import Component from "vue-class-component";
import { Action, Getter } from "vuex-class";
import ModalSuccess from "@/components/common/ModalSuccess.vue";
import { objForEachKey } from "@microsoft/applicationinsights-core-js";
import ErrorService from "@/services/erroService";
import RefreshStore from "@/services/refreshStore";
const namespace = "customer";

@Component({
  components: {
    Feedback,
    ModalSuccess,
  },
  methods: {
    formatMoney,
    formatDate,
    truncate,
  },
})
export default class Products extends Vue {
  @Getter("getUser", { namespace: "auth" }) user!: UserInterface;

  @Getter("getIsSaving", { namespace: "excel" }) isSavingFile!: boolean;

  @Getter("getIsExporting", { namespace: "excel" }) isExportingFile!: boolean;

  @Getter("getProductsToExcel", { namespace: "excel" })
  productsToExcel!: ProductExcel[];

  @Getter("getExcelColumnsData", { namespace: "excel" })
  excelColumnsData!: any;

  @Getter("getProductsState", { namespace: "product" })
  products!: Product[];

  @Action("setProductsState", { namespace: "product" })
  setProductsState!: (products: Product[]) => void;

  @Action("setFeedback", { namespace: "feedBack" })
  setFeedBack!: (feedback: FeedBackInterface) => void;

  @Action("setModalJobInfoState", { namespace: "customer" })
  setModalJobInfoState!: (show: boolean) => void;

  @Action("setIsSavingFile", { namespace: "excel" })
  setSaving!: (saving: boolean) => void;

  @Action("setIsExportingFile", { namespace: "excel" })
  setExporting!: (exporting: boolean) => void;

  @Action("importProductsFromExcel", { namespace: "excel" })
  importProductsFromExcel!: (data: {
    file: Blob;
    http: AxiosInstance;
  }) => Promise<ExcelResponse>;

  @Action("setProductsToExcel", { namespace: "excel" })
  setProductsToExcel!: (productsToExcel: ProductExcel[]) => void;

  @Action("convertToProductExcel", { namespace: "excel" })
  convertToProductExcel!: (product: Product) => ProductExcel;

  @Action("removeProduct", { namespace: "product" }) removeProduct!: (id: string) => void;

  @Action("getProductsExcelFile", { namespace: "excel" })
  getProductsExcelFile!: (data: {
    products: ProductExcel[];
    http: AxiosInstance;
  }) => Promise<string>;

  public formatDate = formatDate;
  selectedDomicile = "";
  titleFilter = "";
  areaFilter = "";
  statusFilter = "";
  publishedFilter = "";
  investorTypeFilter = "";
  domicileFilter = "";
  openSuccessModal = false;
  openSuccessModalMessage = "";
  selectedProducts: any[] = [];
  public displayFeedback = (message: string) => {
    this.setFeedBack({
      showFeedBack: true,
      color: "#ae2012",
      text: message
        ? message.charAt(0).toUpperCase() + message.slice(1)
        : "Some strange error happened",
    });
  };

  async handleProducts() {
    this.loadingProducts = true;
    try {
      const productsResponse = await getProducts(this.endpoint.products, this.$http);
      this.setProductsState(productsResponse);
      await this.loadExcel();
    } catch (error) {
      ErrorService.onError({
        status: -1,
        message: "Products:Index:handleProducts",
        error,
      });
    }
    this.loadingProducts = false;
  }
  get hasSelectedProduct() {
    return this.selectedProducts.length > 0;
  }
  get filteredProducts() {
    const conditions: any[] = [];
    if (this.titleFilter) {
      conditions.push((item: Product) =>
        item.title.toLowerCase().includes(this.titleFilter.toLowerCase())
      );
    }

    if (this.areaFilter) {
      conditions.push((item: Product) =>
        item.area.toLowerCase().includes(this.areaFilter.toLowerCase())
      );
    }

    if (this.statusFilter) {
      conditions.push((item: Product) =>
        item.status.toLowerCase().includes(this.statusFilter.toLowerCase())
      );
    }

    if (this.publishedFilter) {
      conditions.push((item: Product) =>
        item.published
          .toString()
          .toLowerCase()
          .includes(this.publishedFilter.toLowerCase())
      );
    }

    if (this.investorTypeFilter) {
      conditions.push((item: Product) =>
        item.investorType
          .toString()
          .toLowerCase()
          .includes(this.investorTypeFilter.toLowerCase())
      );
    }

    if (this.domicileFilter) {
      conditions.push(
        (item: Product) =>
          item.domicile.toString().toLowerCase() == this.domicileFilter.toLowerCase()
      );
    }
    return applyCondition<Product>(this.products, conditions);
  }

  private endpoint = new Endpoint();

  loadingProducts = false;
  headers: Header[] = CustomerProduct.header;

  async mounted() {
    try {
      if (!this.products || this.products.length == 0) await this.handleProducts();
      else await this.loadExcel();
    } catch (error) {
      ErrorService.onError({ status: -1, message: "Products:Index:Mounted", error });
    }
  }

  async loadExcel() {
    const productsCopy = await Promise.all(
      this.products.map((product) => {
        return this.convertToProductExcel(product);
      })
    );
    const cleanCopy = await Promise.all(
      productsCopy.map((copy) => {
        if (copy.fees) copy.fees = copy.fees.replace(/(<([^>]+)>)/gi, "");
        return copy;
      })
    );
    this.setProductsToExcel(cleanCopy);
  }

  showProduct(product: Product) {
    router.push({
      name: "ProductDetail",
      params: {
        productId: product.id,
      },
      query: { type: "view" },
    });
  }

  public async exportProductsToExcel() {
    this.setExporting(true);
    if (this.products.length > 0) {
      const data = {
        products: this.productsToExcel,
        http: this.$http,
      };
      try {
        const response = await this.getProductsExcelFile(data);
        if (response) {
          const link = document.createElement("a");
          link.href = response;
          link.setAttribute("download", "Products");
          document.body.appendChild(link);
          link.click();
        }
      } catch (error) {
        ErrorService.onError({
          status: -1,
          message: "Products:Index:ExportProductsToExcel",
          error,
        });
      }
    }
    this.setExporting(false);
  }

  public async parseExcelFile(name: string, files: Blob[]) {
    if (files.length > 0) {
      this.setSaving(true);
      const data = {
        file: files[0],
        http: this.$http,
      };
      const response = await this.importProductsFromExcel(data);
      const fileInput = document.getElementById("importXls") as HTMLInputElement;
      fileInput.value = "";
      this.handleProducts();
      this.setSaving(false);
      if (response.hasErrors) {
        const capitalizedArray = response.errors.map(
          (message) => message.charAt(0).toUpperCase() + message.slice(1)
        );
        const messages = response.errors.join("\r\n");
        this.displayFeedback(messages);
      }
    }
  }

  async clearCache() {
    this.loadingProducts = true;

    try {
      const result = await putProductClearCache(
        this.endpoint.productClearCache,
        this.$http
      );
    } catch (error) {
      ErrorService.onError({ status: -1, message: "Products:Index:ClearCache", error });
    }
    this.loadingProducts = false;
  }

  deleteProducts(): void {
    this.$confirm("Do you really want to delete this select products?").then((res) => {
      if (res) {
        const url = `${this.endpoint.productDelete}`;
        const productIds = this.selectedProducts.map((x) => x.id);
        this.loadingProducts = true;
        this.$http
          .post(`${url}`, { productIds })
          .then((res: any) => {
            productIds.forEach((p) => this.removeProduct(p));

            this.openSuccessModalMessage = "Deleted product(s) with success!";
            this.selectedProducts = [];
            this.openSuccessModal = true;
            this.loadingProducts = false;
          })
          .catch((error) => {
            ErrorService.onError({
              status: -1,
              message: "Products:Index:DeletedProducts",
              error,
            });
            this.loadingProducts = false;
          });
      }
    });
  }
}
